import {Text} from 'quickstart/components/content/Text'
import {Stack} from 'quickstart/components/layout/Stack'
import {MetaLink} from 'quickstart/components/tizra/MetaLink'
import {logger, meta, semiSplit} from 'tizra'
import type {BrowseGalleryProps} from '..'
import {FitStack} from './FitStack'
import {useInfiniteBrowse} from './useInfiniteBrowse'

const log = logger('BrowseGallery/tiles')

/**
 * Right side of a Headline block
 */
export const TitlesGallery = ({
  maxItems,
  search,
  slots,
  twoColumnHeadline = false,
}: BrowseGalleryProps) => {
  const {bottomRef, items} = useInfiniteBrowse({maxItems, search})

  const children = items?.map((r, i) => (
    <Text
      key={meta.key(r)}
      variant="textMd"
      ref={i === items.length - 1 ? bottomRef : undefined}
    >
      <MetaLink
        metaObj={r}
        variant="stealth"
        prop={[...semiSplit(slots?.title?.prop), '_name']}
      />
    </Text>
  ))

  return twoColumnHeadline ?
      <FitStack divided spacing="xl" wrapChildren={false}>
        {children}
      </FitStack>
    : <Stack divided startCapped spacing="xl" wrapChildren={false}>
        {children}
      </Stack>
}
